import { ApiError } from '@/api/error'
import { toError } from '@/utils/error'

export function checkInMaintenance(error: Error | unknown) {
  error = toError(error)
  if (
    error instanceof ApiError &&
    error.status === 503 &&
    error.errorCode &&
    isMaintenanceErrorCode(error.errorCode)
  ) {
    return true
  }
  return false
}

// isMaintenanceErrorCode サーバーから返されるエラーコードの下位16ビットを見てメンテナンスなのかを判定する
export function isMaintenanceErrorCode(errorCode: number): boolean {
  const lower16Bits = errorCode & 0xffff // AND演算で下位16ビットを取得（0xffff:16進数表記の整数リテラル）
  if (lower16Bits === 54) {
    return true
  }
  return false
}
